module.exports = __webpack_public_path__ + "img/typescript.3de182d2.svg";